exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.edit-deliverable-modal.edit-department-modal .field-header {\n  border: unset;\n  background: linear-gradient(to bottom, var(--wf-secondary) 0%, var(--edit-deliverable-modal-edit-department-modal-field-header-lgbg) 86%, var(--db-collapse-control-lgbg) 100%);\n}\n.edit-deliverable-modal.edit-department-modal .field-box .field-wrap {\n  border: unset;\n}\n", ""]);

// exports
